export const FILL_BAG_DEFAULT_INPUTS = {
  weight: '1',
  fillDate: new Date(),
  parameters: {},
} as {
  weight: string;
  fillDate: Date | null;
  parameters: Record<number, string>;
};
